import { Star, BadgeCheck } from "lucide-react";

const Stars = ({ n, size = 14 }) => (
  <span className="flex gap-0.5">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} size={size} className={i < Math.round(n) ? "fill-gold text-gold" : "text-cream/25"} />
    ))}
  </span>
);

export const Reviews = ({ summary, reviews }) => {
  if (!summary) return null;
  const total = summary.count || 1;
  return (
    <div data-testid="reviews-section" className="border-t border-white/10 pt-12">
      <h2 className="font-serif text-2xl sm:text-3xl text-cream mb-8">Customer Reviews</h2>
      <div className="grid md:grid-cols-3 gap-10">
        <div>
          <div className="text-5xl font-serif text-cream">{summary.average}</div>
          <Stars n={summary.average} size={18} />
          <p className="text-cream/60 text-sm mt-2">{summary.count} verified reviews</p>
          <div className="mt-5 space-y-1.5">
            {[5, 4, 3, 2, 1].map((s) => (
              <div key={s} className="flex items-center gap-2 text-xs text-cream/60">
                <span className="w-3">{s}</span>
                <Star size={11} className="fill-gold text-gold" />
                <div className="flex-1 h-1.5 bg-white/10 rounded">
                  <div className="h-full bg-gold rounded" style={{ width: `${((summary.breakdown?.[s] || 0) / total) * 100}%` }} />
                </div>
                <span className="w-5 text-right">{summary.breakdown?.[s] || 0}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="md:col-span-2 space-y-6">
          {(reviews || []).slice(0, 6).map((r) => (
            <div key={r.id} data-testid={`review-${r.id}`} className="border-b border-white/10 pb-5">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <span className="font-medium text-cream">{r.author}</span>
                  {r.verified && <BadgeCheck size={15} className="text-forest" />}
                </div>
                <span className="text-cream/40 text-xs">{r.date}</span>
              </div>
              <Stars n={r.rating} />
              <p className="font-medium text-cream mt-2">{r.title}</p>
              <p className="text-cream/65 text-sm mt-1 leading-relaxed">{r.body}</p>
            </div>
          ))}
          {(!reviews || reviews.length === 0) && (
            <p className="text-cream/50">Be the first to review this product.</p>
          )}
        </div>
      </div>
    </div>
  );
};
